// extracted by mini-css-extract-plugin
var _1 = "NewSelectOption-module__animatedBackground--S_uzl";
var _2 = "NewSelectOption-module__newIconContainer--jf6Z0";
export { _1 as "animatedBackground", _2 as "newIconContainer" }
